import bookEn from './en/en.json'
import bookAr from './ar/ar.json'
import bookEs from './es/es.json'
import bookDe from './de/de.json'
import bookIt from './it/it.json'
import bookFr from './fr/fr.json'
import bookPt from './pt/pt.json'
import bookEl from './el/el.json'
import bookBn from './bn/bn.json'
import bookSr from './sr/sr.json'
import bookCs from './cs/cs.json'
import bookPl from './pl/pl.json'
import bookHu from './hu/hu.json'
import bookSk from './sk/sk.json'
import bookRo from './ro/ro.json'
import bookBg from './bg/bg.json'
import bookMk from './mk/mk.json'
import bookSq from './sq/sq.json'

const BookMessages = {
  en: { book: { ...bookEn } },
  ar: { book: { ...bookAr } },
  es: { book: { ...bookEs } },
  de: { book: { ...bookDe } },
  it: { book: { ...bookIt } },
  fr: { book: { ...bookFr } },
  pt: { book: { ...bookPt } },
  el: { book: { ...bookEl } },
  bn: { book: { ...bookBn } },
  sr: { book: { ...bookSr } },
  cs: { book: { ...bookCs } },
  pl: { book: { ...bookPl } },
  hu: { book: { ...bookHu } },
  sk: { book: { ...bookSk } },
  ro: { book: { ...bookRo } },
  bg: { book: { ...bookBg } },
  mk: { book: { ...bookMk } },
  sq: { book: { ...bookSq } },
}

export default BookMessages
